var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9895 0.724045C20.8866 0.660705 20.7547 0.673982 20.6702 0.761049L10.3498 11.087C10.2786 11.1556 10.2549 11.2638 10.2917 11.3589L13.9783 20.946C14.0179 21.0464 14.1128 21.1097 14.2184 21.1097H14.2262C14.3344 21.1071 14.4295 21.0385 14.4637 20.9356L21.1009 1.02247C21.1379 0.911455 21.0904 0.787606 20.9901 0.72426L20.9895 0.724045Z",
    fill: "#00E194"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3883 0.122131C20.3276 0.021785 20.2035 -0.0256633 20.0901 0.0139501L0.174209 6.65109C0.0712496 6.68548 0.00268826 6.78039 7.48647e-05 6.88857C-0.00253709 6.99936 0.063415 7.09709 0.163761 7.13671L9.75365 10.8207C9.78522 10.8312 9.81438 10.8366 9.84594 10.8366C9.9119 10.8366 9.97785 10.8103 10.0253 10.7628L20.3513 0.441833C20.4357 0.357162 20.4516 0.225255 20.3883 0.122296L20.3883 0.122131Z",
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d8b8af13fef132324ec8a9b6addbd725.svg";
export { ForwardRef as ReactComponent };